import { FC, useEffect, useState } from 'react'
import { KTIcon } from '../../../../../../_metronic/helpers'
import { useTheme } from '../../../../../../_metronic/partials/layout/app-theme/ThemeContext'
import Table from '../../common/Table'
import TableHeader from '../../common/TableHeader'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../../redux/store'
import {
  getCatalogueListApi,
  deleteCatalogueApi,
} from '../../../../../redux/slices/CatalogueSlice'
import { toast } from 'react-toastify'


const CatalogueTable: FC = () => {
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchKey, setSearchKey] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const [selectedRow, setSelectedRow] = useState([])
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { theme } = useTheme()

  const catalogueData = useSelector(
    (state: RootState) => state.catalogue.CatalogueList?.data?.data || []
  )
  const catalogueTotal = useSelector(
    (state: RootState) => state.catalogue.CatalogueList?.data?.total || 0
  )

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedSearchQuery(searchKey)
    }, 1000)

    return () => clearTimeout(debounceTimeout)
  }, [searchKey])

  const fetchCatalogueList = () => {
    setLoading(true)
    dispatch(
      getCatalogueListApi({
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        filterkey: debouncedSearchQuery,
      })
    )
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        toast.error('Failed to fetch catalogue data')
      })
  }

  useEffect(() => {
    fetchCatalogueList()
  }, [currentPage, rowsPerPage, debouncedSearchQuery])

  const handleEdit = (id: any) => {
    navigate(`edit/${id}`)
  }
  const handleView = async (id: any) => {
    try {
      const response: any = await dispatch(
        getCatalogueListApi({
          pageNumber: currentPage,
          pageSize: rowsPerPage,
          filterkey: "",
        })
      );
  
      const selectedCatalogue = response.payload?.data?.data?.find((catalogue: any) => catalogue.id === id);
      const catalogue_drive_link = selectedCatalogue?.catalogue_drive_link || selectedCatalogue?.catalogue_drive_link;
  
      if (catalogue_drive_link) {
        window.open(catalogue_drive_link, "_blank");
      } else {
        toast.error("Dive link not found");
      }
    } catch (error) {
      toast.error("Error fetching catalogue data");
    }
  };
  

  const handleDelete = (id: any) => {
    dispatch(deleteCatalogueApi(id)).then((response: any) => {
      if (response.payload.success) {
        toast.success(response.payload.reason)
        fetchCatalogueList()
      } else {
        toast.error(response.payload.reason || 'Something went wrong')
      }
    })
  }

  const handleSearchChange = (searchQuery: string) => {
    setSearchKey(searchQuery)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setCurrentPage(page)
    setRowsPerPage(newPerPage)
  }

  const columnData = [
    { name: 'Name', selector: (row: any) => row?.name, sortable: true },
    // { name: 'Catalogue Drive Link', selector: (row: any) => row?.catalogue_drive_link, sortable: true },
    {
      name: 'Status',
      cell: (row: any) => (row?.is_active === 1 ? 'Active' : 'Inactive'),
      sortable: true,
    },
    {
      name: 'Created At',
      selector: (row: any) => new Date(row?.created_at).toLocaleDateString(),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <div>
          <div
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => handleView(row?.id)}
          >
            <KTIcon iconName='eye' className='fs-3' /> 
          </div>
          <div
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => handleEdit(row?.id)}
          >
            <KTIcon iconName='pencil' className='fs-3' />
          </div>
          <div
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => handleDelete(row?.id)}
          >
            <KTIcon iconName='trash' className='fs-3' />
          </div>
        </div>
      ),
      sortable: false,
      style: { textAlign: 'left' },
    },
  ]

  return (
    <div className='card'>
      <TableHeader
        search={searchKey}
        addButtonText={'Add Catalogue'}
        handleSearchChange={handleSearchChange}
        handleAddButton={() => navigate('add')}
        showFilter={true}
        filterContent={<p>Custom filter form content here</p>}
      />

      <div className='card-body p-0 shadow-sm'>
        <Table
          data={catalogueData}
          columns={columnData}
          isLoading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
          totalRows={catalogueTotal}
          showPagination={true}
          onRowClicked={(row) => {
          }}
          selectableRows
          onSelectedRowsChange={(selected) => {
            setSelectedRow(selected.selectedRows)
          }}
        />
      </div>
    </div>
  )
}

export default CatalogueTable
